import type { ReactNode } from 'react'

export interface ClaimsFlowMainProps {
  children: ReactNode
  /**
   * Desktop-only column (e.g. {@link ClaimsDesktopProgress}). Hidden below `md` so mobile layout is unchanged.
   */
  aside?: ReactNode
}

/**
 * Shared cream content column for Make a claim steps — padding bumped so shorter steps
 * match the breathing room of the first screen; no nested scroll (whole page scrolls).
 */
export default function ClaimsFlowMain({ children, aside }: ClaimsFlowMainProps) {
  return (
    <main
      id="main"
      className="relative mx-auto flex min-h-[68vh] w-full max-w-container-desktop flex-col items-stretch gap-[24px] px-[16px] py-[48px] md:gap-[32px] md:px-[32px] md:py-[64px]"
    >
      <div
        className={
          aside
            ? 'flex w-full flex-col items-stretch gap-[24px] md:flex-row md:items-start md:justify-between md:gap-10 lg:gap-12'
            : 'flex w-full flex-col'
        }
      >
        <div className="relative flex w-full max-w-[768px] min-w-0 flex-col items-start gap-[24px] md:gap-[32px]">
          {children}
        </div>
        {aside ? (
          <aside className="hidden min-w-0 shrink-0 md:block md:w-[min(100%,280px)] lg:w-[300px]">
            <div className="md:sticky md:top-[24px]">{aside}</div>
          </aside>
        ) : null}
      </div>
    </main>
  )
}
